export default "<app-header></app-header>\n<user-left-menu></user-left-menu>\n<router-outlet></router-outlet>\n<app-footer></app-footer>\n";